import styled from "styled-components";

export const StyledCategoryName = styled.h1`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
`;
